//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MobileMenu',

  props: {
    menuHeader: {
      type: Array,
      default: function() {
        return [];
      }
    },
    categories: {
      type: Array,
      default: function() {
        return [];
      }
    },
    wishlistCount: {
      type: Number,
      default: 0
    },
    itemsCount: {
      type: Number,
      default: 0
    },
    itemsCount: {
      type: Number,
      default: 0
    },
    appCfg: {
      type: Object,
      default: function() {
        return {};
      }
    },
    appVars: {
      type: Object,
      default: function() {
        return {};
      }
    },
    cityName: {
      type: String,
      default() {
        return this.appCfg?.city?.model?.name || "Екатеринбург";
      },
    },
  },

  emits: [
    'openPopupAuthorizationMyAcuvue'
  ],

  computed: {
    telegramLinkLinzaruBot: function () {
      return this.$store?.state?.appState?.vars?.["telegram_link_linzaru_bot"] || "#"
    },
    isJJ: function () {
      return this.$store.state?.['local-settings']?.isJJ
    }
  },

  methods: {

    onClose: function() {
      this.$emit('close');
    },

    openSelectCity: function() {
      this.onClose();
      this.$emit('onSelectCity');
    },

    handleClickAcuvue() {
      const isAcuvueUser = Boolean(Object.keys(this.$store?.state?.myacuvue?.profile)?.length > 0);
      if (isAcuvueUser) {
        this.$router.push({path: '/profile/my-acuvue'})
      } else {
        this.$emit('close')
        this.$emit('openPopupAuthorizationMyAcuvue')
      }
    }

  }
};
